

export class NavigationClientBE {
    constructor(){}
    IpAddress: string;
    TypeBrowser: string;
    SessionID: string;
    Referring_Page: string;
    DestinationServer: string;
}